module.exports = __webpack_public_path__ + "assets/img/free_12.3ac34497.png";